import type { User } from '@gcv/shared';

import { getAssigneeName } from './get-assignee-name';

interface TaskWithAssignment {
  assigned_users?: Partial<User>[];
  assigned_group_ids?: string[];
  assigned_groups?: { id: string; name: string }[];
}

export interface GroupedAssigneeResult {
  label: string;
  uniqueNames: string[];
}

export const getGroupedAssigneeName = (
  bankGroups: { id: string; name: string }[],
  tasks: TaskWithAssignment[]
): GroupedAssigneeResult => {
  const assigneeNames = tasks.map(
    (t) => getAssigneeName(bankGroups, t.assigned_users, t.assigned_group_ids, t.assigned_groups) || '--'
  );
  const uniqueNames = [...new Set(assigneeNames)];

  if (uniqueNames.length > 1) {
    return { label: 'Multiple', uniqueNames };
  }

  return { label: uniqueNames[0] ?? '--', uniqueNames };
};
